<router-outlet></router-outlet>
<nav class="bottom-nav">
  <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
    <mat-icon>home</mat-icon>
    <span>Inicio</span>
  </a>
  <a routerLink="/form" routerLinkActive="active">
    <mat-icon>description</mat-icon>
    <span>Formulario</span>
  </a>
  <a routerLink="/contacto" routerLinkActive="active">
    <mat-icon>contact_mail</mat-icon>
    <span>Contacto</span>
  </a>
</nav>
